const TRACKING_ID = "G-PMK934W4TJ";
export default TRACKING_ID;
